var map = {
	"./currency_1.png": 482,
	"./currency_2.png": 297,
	"./currency_3.png": 432,
	"./currency_4.png": 599,
	"./currency_5.png": 286,
	"./currency_6.png": 637,
	"./currency_7.png": 540,
	"./currency_8.png": 699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;